import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../styles/careers.css";
import careerList from './careers.json';
function Careers() {
    // Rendered by backend in the future?
    const [inputValue, setInputValue] = useState('');
    
    const [careers, setCareers] = useState(careerList);

    function filterCareers(e) {
        e.preventDefault();
        if (!inputValue) {
            setCareers(careerList);
            return;
        }
        const filteredCareers = careerList.filter(career => career.title.toLowerCase().includes(inputValue.toLowerCase()));
        setCareers(filteredCareers);
    }
    return (
        <div className='career-page container col'>
            <h1>Careers</h1>
            <p>Search for a career you're interested in, try it, and reflect! More careers coming soon.</p>
            <form className='search-careers row' onSubmit={filterCareers}>
                <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} type="text" placeholder="Search for a career" />
                <button type="submit" className="search-btn" style={{ width: "30px", height: "30px" }}><i className="fa fa-paper-plane" style={{ color: 'white' }}></i></button>
            </form>
            <div className='careers-container'>
                {
                    careers.map((career) => {
                        return (
                            <Link to={career.route} key={career.title}>
                                <div className='career-card row'>
                                    <div className='career-image col'>
                                        <img src={require("../img/career-icons/" + career.id + ".png")} alt={career.title} />
                                    </div>
                                    <div className='description col'>
                                        <p>{career.title}</p>
                                        <div className='career-tags row'>
                                            {
                                                career.tags.map((tag) => {
                                                    return <div key={tag} className={'tag ' + tag}>{tag}</div>
                                                })
                                            }
                                        </div>

                                    </div>
                                </div>
                            </Link>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Careers;